import { render } from "./WelcomeImage.vue?vue&type=template&id=d334584a&scoped=true"
import script from "./WelcomeImage.vue?vue&type=script&lang=js"
export * from "./WelcomeImage.vue?vue&type=script&lang=js"

import "./WelcomeImage.vue?vue&type=style&index=0&id=d334584a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d334584a"]])

export default __exports__